import { ComponentType, PropsWithChildren, PureComponent } from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { ProfilecardTriggerPosition } from '@atlaskit/profilecard';

import { Team, User } from 'src/components/types';
import {
  DeletedUserName,
  UserName as BaseUserName,
  UserProfileCardTrigger,
  getName,
} from 'src/components/user-profile';
import { userProfileClient } from 'src/utils/profile-client';

type Props = {
  // TODO: Upgrade to ElementType when on a newer version of @types/react and typescript
  linkComponent: ComponentType<PropsWithChildren<any>> | string;
  profileCardPosition?: ProfilecardTriggerPosition;
  profileCardTrigger: 'click' | 'hover';
  user: Team | User | null | undefined;
};

export class UserName extends PureComponent<Props> {
  static defaultProps = {
    // TODO: Upgrade to ElementType when on a newer version of @types/react and typescript
    /* eslint react/default-props-match-prop-types: "warn" */
    linkComponent: 'a' as ComponentType<PropsWithChildren<any>> | string,
    profileCardTrigger: 'hover' as 'click' | 'hover',
  };

  render() {
    const {
      linkComponent: LinkComponent,
      profileCardPosition,
      profileCardTrigger,
      user,
    } = this.props;

    if (!user) {
      return (
        <DeletedUserName
          hasProfileCard
          profileCardPosition={profileCardPosition}
          profileCardTrigger={profileCardTrigger}
        />
      );
    }

    // Temporarily link to the profile page until workspace UI is enabled (and the profile page is gone)
    const href = undefined;

    const name = <BaseUserName user={user} />;

    const wrappedName = href ? (
      <LinkComponent href={href}>{name}</LinkComponent>
    ) : (
      // ProfileCardTrigger children must be wrapped in a DOM element (can't just be a primitive string/number/etc)
      // in order to correctly position the card
      <Box as="span" xcss={xcss({ color: 'color.text' })}>
        {name}
      </Box>
    );

    // Temporarily disable profile cards for teams until we launch workspaces (PHAROS-465)
    if (user.type === 'team') {
      return wrappedName;
    }

    return (
      <UserProfileCardTrigger
        position={profileCardPosition}
        profileUrl={href}
        profileClient={userProfileClient}
        trigger={profileCardTrigger}
        userId={user.uuid}
        fullName={getName(user)}
      >
        {wrappedName}
      </UserProfileCardTrigger>
    );
  }
}
